export default "__VITE_ASSET__BJn8LDp5__"